export default __webpack_public_path__ + "static/media/waves_blue.408072a5.svg";